import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WebSocketService } from '../websocket.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit{
  username:any
  email:any
  token: any
  enableDataInsight:boolean = false;
  constructor(public router:Router,private webSocketService: WebSocketService){

  }

  ngOnInit(): void {
    this.username = localStorage.getItem('username')
    this.email = localStorage.getItem('email')
    this.token  = localStorage.getItem('token')
    const value = localStorage.getItem('enableDataInsight');
    this.enableDataInsight = value === '1';
    this.webSocketService.connect(this.token)
  }

  logout(){
    localStorage.clear();
    this.router.navigate(['/']);
    this.webSocketService.disconnect();
    // this.isConnected = false;
  }

}
